const API_URL = "https://api.jsonpress.in/api/v1/public/blog";
const API_KEY = "a6aaa253a352e71770647fa1bac692c0b97fd4ab";

export const fetchBlogBySlug = async (slug) => {
  const res = await fetch(`${API_URL}/${slug}`, {
    headers: {
      "x-api-key": API_KEY
    }
  });
  const data = await res.json();
  return data.data;
};
